const aaa = [
   
    {
        path: "returnOrderSee",
        component: () => import("@/views/dingdan/order/returnOrder/see.vue"),
        meta: { title: '订单' },
    },
   
    {
        path: "returnOrderList",
        component: () => import("@/views/dingdan/order/returnOrder/list.vue"),
        meta: { title: '订单', keepAlive: true },
    },
  

    
]
export default aaa;